import React, { useEffect, useState } from "react";
import "./style.css";
import {
  formatDateHumanFriendly,
  getBookingFormatedDateMonthTimeValue,
  getBookingFormatedDateMonthValue,
  getBookingFormatedValue,
  getBookingFormatedValueNew,
  getBookingFormattedData,
  isTravelDateGreaterThanPointTime,
} from "../../../utils/Functions";
import DriverIcon from "../../../assets/drivericon.jpg";
import VerifiedIcon from "../../../assets/verifiedIcon.png";
import DriverSteering from "../../../assets/driverSteering.png";
import AndroidSeatBooking from "../../AndroidSeatBooking";
import { useNavigate } from "react-router-dom";

const SearchListItem = ({
  busValue,
  id,
  name,
  images,
  departure,
  arrival,
  duration,
  rating,
  price,
  seatsAvailable,
  fetchCategories,
  viewSeatId,
  setViewSeatId,
  handleApiRedirect,
}) => {

  const navigate = useNavigate()

  return (
    <section className={`search_main_cab_item_container`}>
      <div className="search_main_cab_item_container_first">
        <aside className="search_main_cab_item_container_first_left">
          <aside className="search_main_cab_item_container_first_left_timing">
            <div className="search_main_cab_item_container_first_left_timing_depart">
              {getBookingFormattedData(new Date(busValue?.departure)).format('MMM DD, YYYY')}
            </div>
            <div className="search_main_cab_item_container_first_left_timing_depart">
              {getBookingFormatedValue(new Date(busValue?.departure))}
            </div>
          </aside>
          <aside className="search_main_cab_item_container_first_left_location">
            <div className="text_section_main">
              <p className="text_section_main_pickup">
                {busValue?.from_location}
              </p>
              <p className="text_section_main_drop">{busValue?.to_location}</p>
            </div>
            <div className="line_wrapper">
              <div className="circle_icon_cab"></div>
              <div className="vertical_line"></div>
              <div className="circle_icon_cab circle_icon_cab_green"></div>
            </div>
          </aside>
        </aside>
        <aside className="search_main_cab_item_container_first_right">
          <span>{seatsAvailable} Seats</span>
          <div className="search_main_cab_item_container_first_right_main">
              <button
                type="button"
                className={`search_main_cab_item_container_first_right_main_button`}
                onClick={() => {
                  navigate(`/post-ride?params=${sessionStorage.getItem('auth')}&ridePost=${JSON.stringify(busValue)}`);
                }}
              >
                Create Ride
              </button>
            </div>
        </aside>
      </div>
    </section>
  );
};

export default SearchListItem;
